import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {DateRange} from 'rsuite/DateRangePicker';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import DateRangePickerControlled from 'shared/ui/Date/DateRangePickerControlled/DateRangePickerControlled';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {dateRangeToFilters, getUrlDateRange, UrlFiltersData} from 'shared/lib/filterHelper';
import {getActiveOptions, getYesNoOptions} from 'shared/lib/filterOptions';

interface IStatusPagesFiltersForm {
    isActive?: string,
    hideBanner?: string,
    createdAt?: DateRange,
}

const StatusPagesFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();

    const {handleSubmit, control} = useForm<IStatusPagesFiltersForm>({
        defaultValues: {
            isActive: searchParams.get('is_active') ?? undefined,
            hideBanner: searchParams.get('hide_banner') ?? undefined,
            createdAt: getUrlDateRange(searchParams, 'created_at'),
        },
    });

    const toFilters = ({isActive, hideBanner, createdAt}: IStatusPagesFiltersForm) => {
        const data: UrlFiltersData = {
            is_active: isActive ?? undefined,
            hide_banner: hideBanner ?? undefined,
        };
        dateRangeToFilters(createdAt, data, 'created_at');

        return data;
    };

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Статус`}>
                <Select
                    control={control}
                    name="isActive"
                    data={getActiveOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Баннеры отключены`}>
                <Select
                    control={control}
                    name="hideBanner"
                    data={getYesNoOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Период создания`}>
                <DateRangePickerControlled control={control} name="createdAt" cleanable={true}/>
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default StatusPagesFiltersForm;
